export * from './backend';

// Local resolvers that take car of the apollo cache
export const resolvers = [];
